module.exports = __webpack_public_path__ + "static/23-tat5-f566b95db4618d8d87df69a86b079aff.jpg";